// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_PERMISSIONS } from "../data/roles";

export function ProtectedRoute({ allowedRoles = [], children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // 1) still loading auth state
  if (loading) return null;

  // 2) not logged in → go to signin
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // 3) flatten all pages this user is allowed to see
  const grants = new Set(
    (user.roles || []).flatMap((r) => ROLE_PERMISSIONS[r] || [])
  );

  // 4) if they have no admin grants at all, kick them home
  if (grants.size === 0) {
    return <Navigate to="/" replace />;
  }

  // 5) if they match one of the allowedRoles for this route, render it
  const hasRole = user.roles.some((r) => allowedRoles.includes(r));
  if (hasRole) {
    return children;
  }

  // 6) otherwise pick the first page they *can* see
  const SECTION_ORDER = [
    "vehicles",
    "feature-catalog",
    "images",
    "requests",
    "users",
    "email-settings",
    "flex-prices",
  ];
  const fallback = SECTION_ORDER.find((key) => grants.has(key)) || "vehicles";
  return <Navigate to={`/admin/${fallback}`} replace />;
}

// // // src/components/ProtectedRoute.jsx
// import React from "react";
// import { Navigate, useLocation } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";
// import { ROLE_PERMISSIONS } from "../data/roles";

// // /**
// //  * Wrap any element/subtree you want to protect.
// //  * @param {ReactNode} children
// //  * @param {string[]} allowedRoles – e.g. ['super-admin','car-admin']
// //  */
// // export function ProtectedRoute({ children, allowedRoles = [] }) {
// //   const { user, token, loading } = useAuth();

// //   // 1) still loading auth state
// //   if (loading) return null;

// //   // 2) not logged in → go to signin
// //   if (!token) return <Navigate to="/signin" replace />;

// //   // 3) no allowed role → unauthorized (could also render a 403 page)
// //   const hasRole =
// //     Array.isArray(user?.roles) &&
// //     user.roles.some((r) => allowedRoles.includes(r));
// //   if (!hasRole) return <Navigate to="/" replace />;

// //   // 4) all good!
// //   return children;
// // }

// export function ProtectedRoute({ allowedRoles, children }) {
//   const { user, loading } = useAuth();
//   const location = useLocation();
//   if (loading) return null;
//   if (!user) {
//     // not even logged in
//     return <Navigate to="/signin" state={{ from: location }} replace />;
//   }

//   // do they have *any* of the allowedRoles?
//   const hasAccess = user.roles.some((r) => allowedRoles.includes(r));
//   if (hasAccess) {
//     return children;
//   }

//   // otherwise pick the first page they *can* see
//   // flatten all their grants
//   const grants = new Set(user.roles.flatMap((r) => ROLE_PERMISSIONS[r] || []));
//   // define the global section order:
//   const SECTION_ORDER = [
//     "vehicles",
//     "feature-catalog",
//     "images",
//     "requests",
//     "users",
//     "email-settings",
//     "flex-prices",
//   ];
//   const fallback = SECTION_ORDER.find((key) => grants.has(key)) || "vehicles";

//   return <Navigate to={`/admin/${fallback}`} replace />;
// }
